import React from 'react';
import { WrapperHover } from '../../hocs/withTooltipHover';
import {
    StyledInfo,
    StyledInfoTextTooltip,
    placementsOptions,
    verticalAlignmentOptions,
} from './workflow-tooltip.styles';

interface TooltipProps {
    verticalAlignment?: 'top' | 'bottom',
    placement?: 'left' | 'center' | 'right',
    text: string,
    children?: React.ReactNode,
    bottom?: number,
    left?: number,
    right?: number,
    top?: number,
    stylesToolTip?: object,
}

const Tooltip = ({
    verticalAlignment = 'top',
    placement = 'center',
    bottom,
    children,
    left,
    right,
    text,
    top,
    stylesToolTip,
}: TooltipProps) => (
    <WrapperHover>
        <StyledInfo
            className="onHoverShowTooltip"
            left={left}
            right={right}
            top={top}
            bottom={bottom}
        >
            <StyledInfoTextTooltip
                placementCSS={placementsOptions[placement]}
                verticalAlignmentCSS={verticalAlignmentOptions[verticalAlignment]}
                stylesToolTip={stylesToolTip}
            >{text}
            </StyledInfoTextTooltip>
        </StyledInfo>
        {children}
    </WrapperHover>
);

export default Tooltip;
